import React from 'react';
import Phone from './Phone';
const PhoneS = ({ color, ...props }) => (React.createElement(Phone, Object.assign({ color: color, size: 24 }, props)));
PhoneS.displayName = 'PhoneS'; // Fix for tsc
export default PhoneS;
//# sourceMappingURL=PhoneS.js.map